module.exports = __webpack_public_path__ + "static/media/5.cd0a5a24.jpg";